module.exports = __webpack_public_path__ + "img/geins-logo.130572af.svg";